function Filters()
{
    this.$filterBlocks = $('.filter-block');
    this.$toggleFilters = $('.toggle-filters');

    this.init();
    this.events();
}

Filters.prototype.init = function()
{
    var self = this;

    this.$filterBlocks.each(function(){
        var $items = $(this).find('>a');

        self.hideItems($items);
    });
}

Filters.prototype.events = function()
{
    var self = this;

    this.$toggleFilters.on('click', function(e){
        e.preventDefault();

        var $this = $(this),
            $span = $this.find('span'),
            $items = $this.closest('.filter-contrainer').find('.filter-block > a');

        if($items.filter(':visible').length !== $items.length) {
            $items.show();
            $span.text('Less');
        } else {
            self.hideItems($items);
            $span.text('More');
        }
    });
}

Filters.prototype.hideItems = function($items)
{
    if($items.length <= 5) return; //don't need to hide items

    var result = [],
        data = []; //create overview of all $items and counts
    $items.each(function(index){
        var $this = $(this);
        data.push({index: index, count: $this.data('count'), checked: $this.hasClass('checked')});
    });

    //sort the $items on count property and return only the 5 highest
    data = data.sort(function compare(a, b) {
        return (a.count < b.count) ? 1 : -1;
    }).slice(0, 5);

    var filter = ''; //create a jQuery filter string for $items
    $.each(data, function(key, object){
        if(key !== 0)
            filter += ', ';

        filter += ':eq('+object.index+'),checked';
    });

    $items.not('.checked').hide();
    $items.filter(filter).show();
}

//Filters.prototype.compare =

$(document).ready(function(){
    if($('.filter-contrainer').length > 0) {
        new Filters();
    }
});